import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, action }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: '1.5rem' }}>
    <div style={{ minWidth: 0 }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#202124', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        {icon && <span style={{ display: 'flex', color: '#1a73e8' }}>{icon}</span>}
        {title}
      </h2>
      {subtitle && (
        <p style={{ fontSize: '0.8125rem', color: '#5f6368', margin: '0.25rem 0 0 0' }}>{subtitle}</p>
      )}
    </div>
    {action && <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>{action}</div>}
  </div>
);

export default PageHeader;
